import React from 'react'
import Flex from 'components/ui/flex'
import Heading from 'components/ui/heading'
import Hotkey from 'components/ui/hotkey'
import ModalWindow from 'components/ui/modal-window'
import Stack from 'components/ui/stack'
import Text from 'components/ui/text'
type Props = {
  isOpen: boolean
  onClose: () => void
}
type Shortcut = {
  label: string
  keys: string[]
  separated?: boolean
}
const shortcuts: Shortcut[] = [
  {
    label: 'Move back/forward through playlists',
    keys: ['←', '→'],
    separated: true,
  },
  {
    label: 'Pause/Playback',
    keys: ['Space'],
  },
  {
    label: 'Individual items select',
    keys: ['cmd', 'Click'],
  },
  {
    label: 'Range select',
    keys: ['⇧', 'Click'],
  },
  {
    label: 'Skip to next track',
    keys: ['⇧', '→'],
  },
  {
    label: 'Skip to previous track',
    keys: ['⇧', '←'],
  },
]

const KeyboardShortcutsModal = ({
  isOpen,
  onClose,
}: Props): React.ReactNode => {
  return (
    <ModalWindow
      header={<Heading>Keyboard shortcuts</Heading>}
      isOpen={isOpen}
      width="small"
      onClose={onClose}
    >
      <Stack space="xxsmall">
        {shortcuts.map((item, index) => (
          <Flex key={index}>
            <Flex.Content>
              <Text type="paragraph">{item.label}</Text>
            </Flex.Content>
            {item.separated ? (
              <Flex spacing="small">
                {item.keys.map((key, index) => (
                  <Hotkey key={index} keys={[key]} appearance="buttons" />
                ))}
              </Flex>
            ) : (
              <Hotkey keys={item.keys} appearance="buttons" />
            )}
          </Flex>
        ))}
      </Stack>
    </ModalWindow>
  )
}

export default KeyboardShortcutsModal
